 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About Sweden~accommodation~get-here~tours":"About Sweden~accommodation~get-here~tours","About Sweden":"About Sweden","accommodation":"accommodation","get-here":"get-here","tours":"tours","Article":"Article","Video":"Video","about":"about","adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd":"adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd","adventures":"adventures","contact-us":"contact-us","hiking-eightdays":"hiking-eightdays","hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private":"hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private","hiking-private":"hiking-private","kayak-private":"kayak-private","skating-private":"skating-private","skiing-adventures":"skiing-adventures","skiing-private":"skiing-private","kayak-weekend":"kayak-weekend","skating-weekend":"skating-weekend","skiing-weekend":"skiing-weekend"}[chunkId]||chunkId) + "." + {"About Sweden~accommodation~get-here~tours":"b1ce9f67","About Sweden":"6b2b1f52","accommodation":"f2121103","get-here":"81e6e403","tours":"66dac6a1","Article":"8f118c6f","Video":"c0279650","about":"3d47ac4d","adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd":"12484d13","adventures":"796c2e28","contact-us":"d9fe5d87","hiking-eightdays":"deaf7fa8","hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private":"c313cae8","hiking-private":"1c4b3082","kayak-private":"2f76b967","skating-private":"05222da6","skiing-adventures":"d65a5607","skiing-private":"e1be5661","kayak-weekend":"eb5dac01","skating-weekend":"3583c0d9","skiing-weekend":"90075d4f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About Sweden~accommodation~get-here~tours":1,"About Sweden":1,"accommodation":1,"get-here":1,"tours":1,"Article":1,"Video":1,"about":1,"adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd":1,"adventures":1,"contact-us":1,"hiking-eightdays":1,"hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private":1,"hiking-private":1,"kayak-private":1,"skating-private":1,"skiing-private":1,"kayak-weekend":1,"skating-weekend":1,"skiing-weekend":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About Sweden~accommodation~get-here~tours":"About Sweden~accommodation~get-here~tours","About Sweden":"About Sweden","accommodation":"accommodation","get-here":"get-here","tours":"tours","Article":"Article","Video":"Video","about":"about","adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd":"adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd","adventures":"adventures","contact-us":"contact-us","hiking-eightdays":"hiking-eightdays","hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private":"hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private","hiking-private":"hiking-private","kayak-private":"kayak-private","skating-private":"skating-private","skiing-adventures":"skiing-adventures","skiing-private":"skiing-private","kayak-weekend":"kayak-weekend","skating-weekend":"skating-weekend","skiing-weekend":"skiing-weekend"}[chunkId]||chunkId) + "." + {"About Sweden~accommodation~get-here~tours":"4771f201","About Sweden":"a29bbdd6","accommodation":"409048be","get-here":"be6e0ad1","tours":"edb63704","Article":"f980cc86","Video":"a6ed84f6","about":"a0923a9c","adventures~contact-us~hiking-eightdays~hiking-private~kayak-private~kayak-weekend~skating-private~sk~330978dd":"8ba6ed66","adventures":"b026f9db","contact-us":"d7d6dd85","hiking-eightdays":"3fb1af6b","hiking-private~kayak-private~skating-private~skiing-adventures~skiing-private":"5c40409f","hiking-private":"dcc43a82","kayak-private":"dcc43a82","skating-private":"5576308e","skiing-adventures":"31d6cfe0","skiing-private":"dcc43a82","kayak-weekend":"3fb1af6b","skating-weekend":"3fb1af6b","skiing-weekend":"3fb1af6b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
